<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: meta.links.create,
                    },
                ]"
            />
        </template>

        <NavLinks :links="meta.links.adaptations" class="mt-1" />

        <div class="" v-if="activity.image_path">
            <div class="mt-1">
                <img :src="activity.image_path" alt="cover" class="h-auto" />
            </div>
        </div>

        <div class="" v-if="activity.accompanying_text">
            <div class="mt-1">
                <p v-html="activity.accompanying_text" class="prose" />
            </div>
        </div>

        <div v-if="activity.materials.length > 0" class="mt-3 md:mt-5">
            <div>
                {{ $tc('messages.materials', 2) }}
            </div>
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="sm:col-span-12">
                    <ul class="">
                        <li v-for="(row, index) in activity.materials" :key="index" class="list-disc">
                            <span v-if="!row.url">
                                {{ row.title }}
                            </span>
                            <a :href="row.url" target="_blank" class="text-indigo-500" v-else>
                                <svg
                                    class="w-4 h-4 inline-block"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                                    ></path>
                                    <path
                                        d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                                    ></path>
                                </svg>
                                <span class="truncate text-ellipsis overflow-hidden">
                                    {{ row.title ? row.title : row.url }}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <QuizReview
            :activity="activity"
            :questions="quiz.questions"
            :students="quiz.students"
            :mode="quiz.mode"
            v-if="quiz"
        />
    </PanelPage>
</template>

<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import QuizReview from '@/components/QuizReview.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        NavLinks,
        QuizReview,
        PanelPage,
    },
    layout: LandingLayout,
    name: 'Edit',
    props: ['meta', 'activity', 'quiz'],
    data() {
        return {};
    },
    mounted() {},
    computed: {},
    methods: {},
};
</script>
